import { lazy } from 'react'

export const CompanyQRsTable = lazy(() => import('./components/CompanyQRsTable'))

export * from './routes'
